'use-strict';

class MyHelpers {
  constructor() {
    /**
     * Please wait...
     * Loading buttons on Login and Signup
     */
    this.mySelectors = ['#wp-submit', '.pmpro_btn-submit-checkout'];

    for (let i = 0; i < this.mySelectors.length; i++) {
      // console.log(this.mySelectors[i]);

      if (document.querySelector(this.mySelectors[i])) {
        this.element = document.querySelector(this.mySelectors[i]);

        this.element.addEventListener('click', (e) => this.clickHandler(e));
      }
    }
    if (document.getElementById('pmpro_message')) {
      if (document.getElementById('pmpro_message').style.display != 'none') {
        // we have an error
        this.errors();
      }
    }
    /**
     * Telephone Auto-formatting
     */
    // PMP Pro User Signup Field
    if (document.querySelector('#phone_number_div')) {
      this.phoneNumber = document.querySelector('#phone_number_div');

      this.phoneNumber.addEventListener('keydown', (e) => this.onKeyDown(e));
      this.phoneNumber.addEventListener('keyup', (e) => this.onKeyUp(e));
    }

    // BuddyPress Edit Profile Field
    if (document.querySelector('#field_47')) {
      this.phoneNumber = document.querySelector('#field_47');

      this.phoneNumber.addEventListener('keydown', (e) => this.onKeyDown(e));
      this.phoneNumber.addEventListener('keyup', (e) => this.onKeyUp(e));
    }
  }

  onKeyDown(e) {
    var filter = [];

    //since we're looking for phone numbers, we need
    //to allow digits 0 - 9 (they can come from either
    //the numeric keys or the numpad)
    const keypadZero = 48;
    const numpadZero = 96;

    //add key codes for digits 0 - 9 into this filter
    for (var i = 0; i <= 9; i++) {
      filter.push(i + keypadZero);
      filter.push(i + numpadZero);
    }

    //add other keys that might be needed for navigation
    //or for editing the keyboard input
    filter.push(8); //backspace
    filter.push(9); //tab
    filter.push(46); //delete
    filter.push(37); //left arrow
    filter.push(39); //right arrow

    if (filter.indexOf(e.keyCode) < 0) {
      e.preventDefault();
      return false;
    }
  }

  /*******************************************************
   * onKeyUp(e)
   * when a key is pressed up, grab the contents in that
   * input field, format them in line with XXX-XXX-XXXX
   * format and validate if the text is infact a complete
   * phone number. Adjust the border color based on the
   * result of that validation
   *******************************************************/
  onKeyUp(e) {
    var input = e.target;
    var formatted = this.formatPhoneText(input.value);
    var isError = this.validatePhone(formatted) || formatted.length == 0;
    var color = isError ? 'gray' : 'red';
    var borderWidth = isError ? '1px' : '3px';
    input.style.borderColor = color;
    input.style.borderWidth = borderWidth;
    input.value = formatted;
  }

  /*******************************************************
   * validatePhone
   * return true if the string 'p' is a valid phone
   *******************************************************/
  validatePhone(p) {
    var phoneRe =
      /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
    var digits = p.replace(/\D/g, '');
    return phoneRe.test(digits);
  }

  /*******************************************************
   * formatPhoneText
   * returns a string that is in XXX-XXX-XXXX format
   *******************************************************/
  formatPhoneText(value) {
    value = this.replaceAll(value.trim(), '-', '');

    if (value.length > 3 && value.length <= 6)
      value = value.slice(0, 3) + '-' + value.slice(3);
    else if (value.length > 6)
      value =
        value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);

    return value;
  }

  /*******************************************************
   * replaceAll
   * returns a string where all occurrences of a
   * string 'search' are replaced with another
   * string 'replace' in a string 'src'
   *******************************************************/
  replaceAll(src, search, replace) {
    return src.split(search).join(replace);
  }

  errors() {
    document.querySelector('.kt-tab-title-2').click();
    // alert('there are errors on your form');
  }

  clickHandler(e) {
    if (e.target.classList.contains('button-primary'));
    this.btnSelected(e);
    if (e.target.classList.contains('pmpro_btn-submit-checkout'));
    this.loginBtnSelected(e);
  }

  async btnSelected(e) {
    const thisElement = e.target;
    try {
      thisElement.classList.add('sending');
      thisElement.value = 'Please wait...';
    } catch (error) {
      // console.log('error');
      // console.log(error);
    }
  }

  loginBtnSelected(e) {}
}

export default MyHelpers;
